import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-2 text-sm text-neutral-900 group-hover:text-primary-600" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "flex flex-col h-full overflow-y-scroll bg-white rounded-l-lg shadow-xl" }
const _hoisted_4 = { class: "relative flex flex-col h-full" }
const _hoisted_5 = { class: "relative flex items-center px-6 pt-6 pb-2 space-x-2 shrink-0" }
const _hoisted_6 = { class: "text-sm text-neutral-900" }
const _hoisted_7 = { class: "group" }
const _hoisted_8 = { class: "absolute top-[50px] left-[5%] w-[90%] z-10 rounded bg-gray-500 p-3 text-white text-xs group-hover:block hidden" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "This type allows a response of one or a few words.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
  /*#__PURE__*/_createTextVNode(" If you wish to add another input field beside this one, simply set the width to half.")
], -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "This type allows a response of numbers.", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
  /*#__PURE__*/_createTextVNode(" If you wish to add another input field beside this one, simply set the width to half.")
], -1)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "This type allows multiple lines of text as a response.", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
  /*#__PURE__*/_createTextVNode(" Use this type for fields that requires long/paragraph response.")
], -1)
const _hoisted_23 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { key: 3 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, "This type allows users to select from a list of predefined options to ensure standardized responses.", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
  /*#__PURE__*/_createTextVNode(" Use this type for fields with fixed set of choices to reduce the the chances of errors. "),
  /*#__PURE__*/_createElementVNode("i", null, "(This type is allowed to have sub-forms.)")
], -1)
const _hoisted_28 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { key: 4 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "This type allows users to select multiple answer from a list of predefined options.", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
  /*#__PURE__*/_createTextVNode(" Use this type to limit/control all the users response.")
], -1)
const _hoisted_33 = [
  _hoisted_30,
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { key: 5 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "This type allows users to choose one from a predefined options.", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
  /*#__PURE__*/_createTextVNode(" Use this type to limit/control all the users response. "),
  /*#__PURE__*/_createElementVNode("i", null, "(This type is allowed to have sub-forms.)")
], -1)
const _hoisted_38 = [
  _hoisted_35,
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { key: 6 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, "This type allows users to answer by switching between two states.", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
  /*#__PURE__*/_createTextVNode(" Use this type to collect yes/no or true/false responses. (This type is allowed to have sub-forms.)")
], -1)
const _hoisted_43 = [
  _hoisted_40,
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = { key: 7 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", null, "This type allows users to choose one from a predefined options.", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
  /*#__PURE__*/_createTextVNode(" Use this type to limit/control all the users response. "),
  /*#__PURE__*/_createElementVNode("i", null, "(This type is allowed to have sub-forms.)")
], -1)
const _hoisted_48 = [
  _hoisted_45,
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = { key: 8 }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, "This type allows users to input external URLs or hyperlinks.", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
  /*#__PURE__*/_createTextVNode(" Use this type to include clickable links from external websites, files, images, etc.")
], -1)
const _hoisted_53 = [
  _hoisted_50,
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = { key: 9 }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("p", null, "This type allows users to specify the date & time by selecting from a calendar.", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
  /*#__PURE__*/_createTextVNode(" Use this type to ensure accurate data entry for event timestamps.")
], -1)
const _hoisted_58 = [
  _hoisted_55,
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = { key: 10 }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", null, "Relevant data and other details", -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "flex flex-col flex-1 px-6 pt-5 pb-6" }
const _hoisted_63 = { class: "flex flex-col flex-1 h-full space-y-5" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-3 text-xs font-semibold text-neutral-600" }, "Choose field date format ", -1)
const _hoisted_66 = { class: "flex flex-col space-y-2" }
const _hoisted_67 = {
  key: 1,
  class: "flex space-x-2"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("p", { class: "pt-1 text-xs font-semibold text-neutral-600" }, "Is field required?", -1)
const _hoisted_69 = { key: 2 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-3 text-xs font-semibold text-neutral-600" }, "Choose field width", -1)
const _hoisted_71 = { class: "flex flex-col space-y-2" }
const _hoisted_72 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-3 text-xs font-semibold text-neutral-600" }, "Field options", -1)
const _hoisted_74 = { class: "overflow-x-hidden overflow-y-scroll h-96" }
const _hoisted_75 = { class: "min-w-full border-none divide-y divide-gray-200" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("thead", { class: "border-b border-gray-100 bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3 text-xs font-semibold text-center text-gray-500 whitespace-nowrap" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Order")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3 text-xs font-semibold text-left text-gray-500 whitespace-nowrap" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Option Name")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3 text-xs font-semibold text-left text-gray-500 whitespace-nowrap" })
  ])
], -1)
const _hoisted_77 = { class: "px-1 py-2" }
const _hoisted_78 = { class: "w-full px-1 py-2" }
const _hoisted_79 = { class: "flex px-1 py-4 space-x-1" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = {
  key: 1,
  class: "w-5 h-5"
}
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "flex items-center justify-end mt-3 text-sm" }
const _hoisted_85 = {
  key: 4,
  class: "mt-3"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-3 text-xs font-semibold text-neutral-600" }, "Select Exiting Dropdown", -1)
const _hoisted_87 = { class: "grid grid-cols-6 space-x-1" }
const _hoisted_88 = { class: "col-span-6 pt-1" }
const _hoisted_89 = {
  key: 0,
  class: "col-span-6 pt-1"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("p", { class: "pt-1 text-xs font-semibold text-neutral-600" }, "Enable Partner Dropdown", -1)
const _hoisted_91 = {
  key: 0,
  class: "flex flex-col pt-2 space-y-5"
}
const _hoisted_92 = { class: "flex space-x-2" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("p", { class: "pt-1 text-xs font-semibold text-neutral-600" }, "Is field required?", -1)
const _hoisted_94 = { key: 0 }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-3 text-xs font-semibold text-neutral-600" }, "Choose field width", -1)
const _hoisted_96 = { class: "flex flex-col space-y-2" }
const _hoisted_97 = { class: "flex justify-between mt-6 space-x-2 shrink-0" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", null, "Add Sub-Form", -1)
const _hoisted_99 = { class: "flex space-x-6" }
const _hoisted_100 = { class: "w-full" }

import { ref, type PropType, onMounted, computed, watch } from "vue";

import { useVuelidate } from '@vuelidate/core'
import { required, requiredIf, minLength, helpers, integer, maxLength} from '@vuelidate/validators'

import ButtonComponent from "@/components/buttons/ButtonComponent.vue";

import TextInput from "@/components/inputs/TextInput.vue";
import ToggleSwitch from "@/components/inputs/ToggleSwitch.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import ContentModal from "@//views/settings/InterventionTypes/Components/ContentModal.vue";

import { InformationCircleIcon, ArrowLeftIcon, PlusIcon, TrashIcon, EyeIcon } from "@heroicons/vue/24/outline";

import {
	TransitionChild,
	TransitionRoot,
} from "@headlessui/vue";

import { FormFieldType } from "@/views/enums/FormFieldType";

import { 
    FieldInterface,
    FormInterface,
    OptionInterface,
} from "@/interfaces/pages/InterventionForm/InterventionFormInterface";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputType',
  props: {
	form: {
		type: Object as PropType<FormInterface>,
		required: true,
	},
	formField: {
		type: Object as PropType<FieldInterface>,
		required: true,
	},
	item: {
		type: Object as PropType<FieldInterface>,
		required: true,
	},
	existingDropdowns: {
        type: Object,
        required: true,
    },
	fieldType: {
		type: Number,
		required: true,
	},
	show: {
		type: Boolean,
		default: false,
	},
	editMode: {
		type: Boolean,
		default: false,
	},
},
  emits: [ 'open', 'close', 'load:form'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const show = ref<boolean>(props.show);
const showSubFromModal = ref<boolean>(false);

// const target = ref<string>('manual');
const hasChildOption = ref<boolean>(props.formField?.option_child ?? false);
const enableChildOption = ref<boolean>(props.formField?.option_child ?? false);
const childOptions = ref<string[]>([]);

const form = ref<FormInterface>(props.form);
const formField = ref<FieldInterface>({...props.formField})
const originalFormField = ref<FieldInterface>(props.formField)
const selectedOption = ref<any>();

const field_width_options = [
    { id: false, label: 'Whole', value: false, radioSelected: null},
    { id: true, label: 'Half', value: true, radioSelected: null},
];

const dateTimeOptions = [
    { id: FormFieldType.DATE_TIME, value: FormFieldType.DATE_TIME, label: 'Date and Time',},
    { id: FormFieldType.DATE, value: FormFieldType.DATE, label: 'Date Only',},
    { id: FormFieldType.TIME, value: FormFieldType.TIME,  label: 'Time Only',},
];

const fixedWidth = [
	FormFieldType.TEXT,
	FormFieldType.LINK,
	FormFieldType.CHECKBOX_OPTION,
	FormFieldType.CHECKBOX_SINGLE
];

const hasOneOption = [
	FormFieldType.CHECKBOX_SINGLE,
	FormFieldType.TOGGLE,
];

const hasExitingOptions = [
	FormFieldType.DROPDOWN_EXISTING,
];

const inDateTimeOptions = [
	FormFieldType.DATE_TIME,
	FormFieldType.DATE,
	FormFieldType.TIME,
];

const distinct = (value:any, vm:any):boolean => {
	const array = formField.value.options.map((item) => parseInt(item.order));

	const duplicates = array.filter((item, index) => array.indexOf(item) !== index);

	return !duplicates.includes(parseInt(value));
}

//Validations
const rules = computed(() => {

	const rules = {
		is_half_width : {
			required,
		},
		is_required : {
			required,
		},
		label : {
			required,
		}
	}; 

	if(props.formField?.has_options && !hasExitingOptions.includes(props.fieldType)) {
		Object.assign(
			rules,
			{ 
				options:{
					requiredIfOptions: required,
					minLength: minLength(1),

					$each: helpers.forEach({
						label: { required },
						order: { 
							required, 
							integer,  
							maxLength: maxLength(formField.value.options?.length ?? 1),
							distinct: helpers.withMessage('Duplicate order value', distinct) 
						},
					})
				}
			}
		)
	}

	if(props.formField?.has_options && hasExitingOptions.includes(props.fieldType)) {
		Object.assign(
			rules,
			{ 
				option_class: { required },
				option_child:{
					label: { requiredIf: requiredIf(enableChildOption.value) },
					input_type: { requiredIf: requiredIf(enableChildOption.value) },
					is_half_width: { requiredIf: requiredIf(enableChildOption.value) },
					is_required: { requiredIf: requiredIf(enableChildOption.value) },
					option_class: { requiredIf: requiredIf(enableChildOption.value) },
					option_trigger_column: { requiredIf: requiredIf(enableChildOption.value) },
				}
			}
		)
	}


	return rules;
});

const vuelidate = useVuelidate(rules, formField);

const errors =  ref<any>([]);

const subFormOptions = computed(():any => {
	const options = [];

	formField.value?.options.forEach(item => {
		if(!item.form){
			options.push({
				id: item.order,
				value: item.order,
				label: item.label,
			})
		}
	});

	return options;
});

const getFieldIcon = (field: number): string => {
    switch (field) {
        case FormFieldType.INPUT:
            return '/assets/icon/intervention/ic-text.svg';
        case FormFieldType.NUMBER:
            return '/assets/icon/intervention/ic-number.svg';
        case FormFieldType.TEXT:
            return'/assets/icon/intervention/ic-textarea.svg';
        case FormFieldType.DROPDOWN:
        case FormFieldType.DROPDOWN_EXISTING:
            return'/assets/icon/intervention/ic-dropdown.svg';
        case FormFieldType.MULTI_SELECT:
            return'/assets/icon/intervention/ic-multiselect.svg';
        case FormFieldType.RADIO:
            return'/assets/icon/intervention/ic-radio-button.svg';
        case FormFieldType.TOGGLE:
            return'/assets/icon/intervention/ic-toggle.svg';
        case FormFieldType.CHECKBOX_SINGLE:
        case FormFieldType.CHECKBOX_OPTION:
            return'/assets/icon/intervention/ic-checkbox.svg';
        case FormFieldType.LINK:
            return'/assets/icon/intervention/ic-link.svg';
        case FormFieldType.TIME:
        case FormFieldType.DATE:
        case FormFieldType.DATE_TIME:
            return'/assets/icon/intervention/ic-datepicker.svg';
        default:
            return '';
    }
}

const openModal = ():void => {
	show.value = true;
}

const close = ():void => {
	show.value = false
	emit('close');
}

const addOptions = () => {
	formField.value.options.push({
		label: hasOneOption.includes(props.fieldType) ? "Yes/No" : null,
		input_type: FormFieldType.OPTION,
		order: (formField.value?.options?.length ?? 0) + 1
	});
};

const deleteOptions = (index: number) => {
    formField.value?.options.splice(index, 1);
};

const setExistingDropdown = (value:any) => {

	const index = props.existingDropdowns.map((item:any) => item.id).indexOf(value);
	
	if(props.existingDropdowns[index]?.child != undefined) {
		hasChildOption.value = true;
		childOptions.value = [ props.existingDropdowns[index]?.child ]

		formField.value.option_child = {
			label: null,
			input_type: FormFieldType.DROPDOWN,
			order: 1,
			is_half_width: true,
			is_required: false,
			option_class: null,
			option_trigger_column: null,
		}
	} else {
		hasChildOption.value = false;

		formField.value.option_child = null;
	}
}

const setChildDropDown = (value: any) => {
	const index = childOptions.value.map((item:any) => item.id).indexOf(value);
	const option = childOptions.value[index];

	formField.value.option_child.option_class = option.value;
	formField.value.option_child.option_trigger_column = option.column;
}

const add = ():void => {
	const result = vuelidate.value.$validate();

	result
		.then((res) => {
			if(res) {
				submit()
			} else {
				getErrors(vuelidate.value);
			}
		}).catch((err) => {
			console.log(err);
		})
}

const submit = ():void => {

	if(!formField.value.order){
		if(fixedWidth.includes(formField.value.input_type)){	
			formField.value.is_half_width = false;
		}

		if(hasOneOption.includes(formField.value.input_type)){
			formField.value.is_required = false;
		}

		form.value.fields.push({
			...formField.value,
			input_type: props.fieldType,
			order: form.value.fields.length
		});
	} else {
		const temp: any = form.value.fields.findIndex((field: any) => {
			return field.order == formField.value.order
		})
		form.value.fields[temp] = {...formField.value}
	}


	// const index = form.value.fields.map((item:FieldInterface) => item.order).indexOf(formField.value.order)
	
	// if(fixedWidth.includes(formField.value.input_type)){	
	// 	formField.value.is_half_width = false;
	// } 
	
	// if(hasOneOption.includes(formField.value.input_type)){
	// 	formField.value.is_required = false;
	// }

	// if(index == -1){
	// 	form.value.fields.push({
	// 		...formField.value,
	// 		input_type: props.fieldType,
	// 		order: form.value.fields.length
	// 	});
	// } else {
	// 	form.value.fields[index] = formField.value
	// }

	show.value = false;
	emit('close');	
}

const getErrors = (validationErrors:any):void => {

	errors.value = []
	validationErrors.$errors.forEach((error:any) => {
		console.log(error);
		if(error.$response){
			const property = error.$property;

			error.$response.$errors.forEach((error:any, index:number) => {
			
				Object.values(error).forEach((error:any) => {
					if(error[0]?.$property != undefined){
						errors.value[`${property}.${index}.${error[0].$property}`] = error[0].$message
					}
				});   

			});
		} else {
			errors.value[error.$propertyPath] = error.$message
		}
	});
}

const viewSubForm = (form:FormInterface):void => {
	emit('load:form', form);
}


const addSubForm = ():void => {
	showSubFromModal.value = false
	
	const index = formField.value?.options?.map((item) => item.order).indexOf(selectedOption.value)

	try {
		const option = formField.value?.options[index];
		
		if(option){
			Object.assign(
				formField.value?.options[index], 
				{ 
					form:  {
						label: `${option.label} Form`,
						fields: [],
					} 
				}
			);
			emit('load:form', formField.value?.options[index].form);
		}
	
		
	} catch (error) {
		console.log(error)
	}
}

const init = ():void => {
	if(
		props.item?.has_options && 
		(formField.value.options?.length == 0 || formField.value.options == null) &&
		!hasExitingOptions.includes(props.fieldType) 
	)
	{
		formField.value.options = []
		addOptions()
	}
}

onMounted(() => {
	init()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.editMode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "col-span-1 rounded bg-gray-50 hover:bg-primary-300 flex flex-col items-center justify-center text-center group p-6 h-[100px] cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal()))
        }, [
          _createElementVNode("p", _hoisted_1, _toDisplayString(__props.item.label), 1),
          _createElementVNode("img", {
            src: getFieldIcon(__props.item.value),
            class: "object-contain h-6 opacity-50 grayscale group-hover:grayscale-0 group-hover:opacity-100",
            alt: "icon"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: show.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "absolute right-0 inset-y-0 w-full overflow-hidden h-[calc(100vh-148px)] z-[9]",
          onClose: _cache[14] || (_cache[14] = ($event: any) => (close()))
        }, [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "transform transition ease-in-out duration-300",
            "enter-from": "translate-x-full",
            "enter-to": "translate-x-0",
            leave: "transform transition ease-in-out duration-300",
            "leave-from": "translate-x-0",
            "leave-to": "translate-x-full"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(ArrowLeftIcon), {
                      class: "w-6 h-6 transition cursor-pointer text-neutral-500 hover:text-primary-600",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (close()))
                    }),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(__props.item.label), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_unref(InformationCircleIcon), { class: "w-5 h-5 cursor-pointer text-primary-600" }),
                      _createElementVNode("div", _hoisted_8, [
                        (__props.item.label == 'Input Field')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_13))
                          : _createCommentVNode("", true),
                        (__props.item.label == 'Number Field')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_18))
                          : _createCommentVNode("", true),
                        (__props.item.label == 'Text Area')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_23))
                          : _createCommentVNode("", true),
                        (__props.item.label == 'Dropdown')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_28))
                          : _createCommentVNode("", true),
                        (__props.item.label == 'Multi Select')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_33))
                          : _createCommentVNode("", true),
                        (__props.item.label == 'Radio Button')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_38))
                          : _createCommentVNode("", true),
                        (__props.item.label == 'Toggle Button')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_43))
                          : _createCommentVNode("", true),
                        (__props.item.label == 'Regular Checkbox' || __props.item.label == 'Checkbox with multiple options')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_48))
                          : _createCommentVNode("", true),
                        (__props.item.label == 'Link')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_53))
                          : _createCommentVNode("", true),
                        (__props.item.label == 'Date and Time' || __props.item.label == 'Date' || __props.item.label == 'Time')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_58))
                          : (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_61))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", null, [
                        _createVNode(TextInput, {
                          type: "text",
                          label: "Field Label",
                          placeholder: "Field Label",
                          id: "field_label",
                          name: "field_label",
                          modelValue: formField.value.label,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formField.value.label) = $event)),
                          error: errors.value?.label
                        }, null, 8, ["modelValue", "error"])
                      ]),
                      (inDateTimeOptions.includes(__props.fieldType))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _hoisted_65,
                            _createElementVNode("div", _hoisted_66, [
                              _createVNode(RadioGroup, {
                                id: "formField.input_type",
                                modelValue: formField.value.input_type,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formField.value.input_type) = $event)),
                                options: dateTimeOptions,
                                name: "input_type"
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!hasOneOption.includes(formField.value.input_type))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createVNode(ToggleSwitch, {
                              value: formField.value.is_required,
                              noPadding: "",
                              onChange: _cache[4] || (_cache[4] = ($event: any) => (formField.value.is_required = !formField.value.is_required))
                            }, null, 8, ["value"]),
                            _hoisted_68
                          ]))
                        : _createCommentVNode("", true),
                      (!fixedWidth.includes(formField.value.input_type))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _hoisted_70,
                            _createElementVNode("div", _hoisted_71, [
                              _createVNode(RadioGroup, {
                                id: "formField.is_half_width",
                                modelValue: formField.value.is_half_width,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formField.value.is_half_width) = $event)),
                                options: field_width_options,
                                name: "field_width"
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!hasExitingOptions.includes(__props.fieldType) && __props.item?.has_options)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                            _hoisted_73,
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("table", _hoisted_75, [
                                _hoisted_76,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formField.value.options, (option, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: index,
                                      class: "relative align-top"
                                    }, [
                                      _createElementVNode("td", _hoisted_77, [
                                        _createVNode(TextInput, {
                                          type: "number",
                                          id: 'sort_' + index,
                                          name: 'sort_' + index,
                                          customClass: "intervention-sortorder border text-center w-9 h-9 rounded text-xs text-neutral-600 border-neutral-100 bg-transparent focus:border-neutral-900 focus:outline-none focus:ring-0",
                                          modelValue: option.order,
                                          "onUpdate:modelValue": ($event: any) => ((option.order) = $event),
                                          class: _normalizeClass(errors.value[`options.${index}.order`] ? 'intervention-sortorder-parent' : ''),
                                          error: errors.value[`options.${index}.order`]
                                        }, null, 8, ["id", "name", "modelValue", "onUpdate:modelValue", "class", "error"])
                                      ]),
                                      _createElementVNode("td", _hoisted_78, [
                                        _createVNode(TextInput, {
                                          id: 'input_' + index,
                                          name: 'input_' + index,
                                          placeholder: "Type options name",
                                          customClass: "h-9 !pr-2 !pl-2 text-xs",
                                          modelValue: option.label,
                                          "onUpdate:modelValue": ($event: any) => ((option.label) = $event),
                                          disabled: hasOneOption.includes(__props.fieldType),
                                          error: errors.value[`options.${index}.label`]
                                        }, null, 8, ["id", "name", "modelValue", "onUpdate:modelValue", "disabled", "error"])
                                      ]),
                                      _createElementVNode("td", _hoisted_79, [
                                        (option.form)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "flex items-center text-sm transition text-secondary-500 hover:text-secondary-700 active:text-secondary-300",
                                              onClick: ($event: any) => (viewSubForm(option.form))
                                            }, [
                                              _createVNode(_unref(EyeIcon), {
                                                class: "w-5 h-5",
                                                "aria-hidden": "true"
                                              })
                                            ], 8, _hoisted_80))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_81)),
                                        ((formField.value.options?.length != 1 && !hasOneOption.includes(props.fieldType)) || option.form_tag || option.report_code)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 2,
                                              class: "flex items-center text-sm text-red-500 transition hover:text-red-700 active:text-red-300",
                                              onClick: ($event: any) => (deleteOptions(index))
                                            }, [
                                              _createVNode(_unref(TrashIcon), {
                                                class: "w-5 h-5",
                                                "aria-hidden": "true"
                                              })
                                            ], 8, _hoisted_82))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]),
                            (!hasOneOption.includes(__props.fieldType))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                  _createElementVNode("div", _hoisted_84, [
                                    _createElementVNode("p", {
                                      class: "flex italic font-medium transition cursor-pointer text-primary-500 hover:text-primary-700 active:text-primary-300",
                                      onClick: addOptions
                                    }, [
                                      _createVNode(_unref(PlusIcon), {
                                        class: "-ml-0.5 mr-2 h-5 w-5",
                                        "aria-hidden": "true"
                                      }),
                                      _createTextVNode(" Add Another Option ")
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (hasExitingOptions.includes(__props.fieldType))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                              _hoisted_86,
                              _createElementVNode("div", _hoisted_87, [
                                _createElementVNode("div", _hoisted_88, [
                                  _createVNode(MultiSelect, {
                                    options: __props.existingDropdowns,
                                    label: "Module",
                                    id: "module",
                                    name: "module",
                                    placeholder: "Select..",
                                    searchable: "",
                                    modelValue: formField.value.option_class,
                                    "onUpdate:modelValue": [
                                      _cache[6] || (_cache[6] = ($event: any) => ((formField.value.option_class) = $event)),
                                      setExistingDropdown
                                    ],
                                    error: errors.value?.option_class
                                  }, null, 8, ["options", "modelValue", "error"])
                                ]),
                                (hasChildOption.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                      _hoisted_90,
                                      _createVNode(ToggleSwitch, {
                                        value: enableChildOption.value,
                                        noPadding: "",
                                        onChange: _cache[7] || (_cache[7] = ($event: any) => (enableChildOption.value = !enableChildOption.value))
                                      }, null, 8, ["value"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (enableChildOption.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                    _createElementVNode("div", null, [
                                      _createVNode(TextInput, {
                                        type: "text",
                                        label: "Field Label",
                                        placeholder: "Field Label",
                                        id: "field_label",
                                        name: "field_label",
                                        modelValue: formField.value.option_child.label,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formField.value.option_child.label) = $event)),
                                        error: errors.value[`option_child.label`]
                                      }, null, 8, ["modelValue", "error"])
                                    ]),
                                    _createVNode(MultiSelect, {
                                      options: childOptions.value,
                                      label: "Partner Module",
                                      id: "module",
                                      name: "module",
                                      placeholder: "Select..",
                                      searchable: "",
                                      modelValue: formField.value.option_child.option_class,
                                      "onUpdate:modelValue": [
                                        _cache[9] || (_cache[9] = ($event: any) => ((formField.value.option_child.option_class) = $event)),
                                        setChildDropDown
                                      ],
                                      error: errors.value[`option_child.option_class`]
                                    }, null, 8, ["options", "modelValue", "error"]),
                                    _createElementVNode("div", _hoisted_92, [
                                      _createVNode(ToggleSwitch, {
                                        value: formField.value.option_child.is_required,
                                        noPadding: "",
                                        onChange: _cache[10] || (_cache[10] = ($event: any) => (formField.value.option_child.is_required = !formField.value.option_child.is_required))
                                      }, null, 8, ["value"]),
                                      _hoisted_93
                                    ]),
                                    (!fixedWidth.includes(formField.value.option_child.input_type))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                          _hoisted_95,
                                          _createElementVNode("div", _hoisted_96, [
                                            _createVNode(RadioGroup, {
                                              id: "formField.option_child.is_half_width",
                                              modelValue: formField.value.option_child.is_half_width,
                                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formField.value.option_child.is_half_width) = $event)),
                                              options: field_width_options,
                                              name: "field_width_child"
                                            }, null, 8, ["modelValue"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("div", null, [
                        (formField.value?.has_sub_form && !hasExitingOptions.includes(__props.fieldType) && __props.editMode)
                          ? (_openBlock(), _createBlock(ButtonComponent, {
                              key: 0,
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (showSubFromModal.value = true))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                                _hoisted_98
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(ButtonComponent, {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (add()))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(__props.editMode ? 'Update' : 'Add') + " Field", 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ], 32)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(ContentModal, {
      show: showSubFromModal.value,
      title: "Add Conditional Form Trigger"
    }, {
      button: _withCtx(() => [
        _createVNode(ButtonComponent, {
          btnWidth: "quinary",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (showSubFromModal.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Cancel ")
          ]),
          _: 1
        }),
        _createVNode(ButtonComponent, {
          customClass: "primary",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (addSubForm()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Submit ")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            _createVNode(MultiSelect, {
              options: subFormOptions.value,
              label: "Option Value",
              id: "option_value",
              name: "option_value",
              placeholder: "Select..",
              searchable: "",
              modelValue: selectedOption.value,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedOption).value = $event))
            }, null, 8, ["options", "modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})